<div
	*ngIf="parcel && (!showSimilar || pin?.sameAdjacentOwners)"
	class="bg-grey-veryLight rounded-xl p-5"
>
	<div class="font-bold">
		<span>{{ primary ? 'Primary' : 'Adjacent' }}</span> PIN {{ pin.pin }}
	</div>
	<div class="flex flex-col mt-5">
		<span class="font-bold">Owners:</span>
		<div
			*ngFor="let owner of parcel.owners"
			class="flex flex-col flex-1"
			[ngClass]="{ 'similar-name': owner.sameName }"
		>
			<div class="flex flex-row flex-1 items-center">
				<span class="flex-1"
					>{{ owner.name | capitalize }} ({{ owner.capacity }})</span
				>
				<fa-icon
					*ngIf="instrument?.sameNamesToIndexes?.includes(i)"
					matTooltip="Common Names Detected"
					class="text-lg text-orange ml-3"
					[icon]="ICON.parties"
				></fa-icon>
			</div>
		</div>
	</div>
	<div class="flex flex-col mt-5 border rounded-md px-5 bg-white">
		<div
			*ngFor="
				let instrument of parcel.instruments
					| filter: 'type' : '===' : 'TRANSFER'
					| sort: ['reg_date'] : ['asc']
			"
			class="instrument flex flex-col flex-1 py-2"
		>
			<div>{{ instrument.reg_date | date: mediumDate }}:</div>
			<div class="flex">
				<div class="w-1/2 pr-2">
					<div class="font-bold">Parties from</div>
					<div
						*ngFor="let name of instrument.parties_from; index as i"
						[ngClass]="{
							'similar-name': instrument?.sameNamesFromIndexes?.includes(i),
						}"
						class="flex flex-col flex-1"
					>
						<div class="flex flex-row flex-1 items-center overflow-hidden">
							<span class="flex-1">
								{{ name | capitalize }}
							</span>
							<fa-icon
								*ngIf="instrument?.sameNamesFromIndexes?.includes(i)"
								matTooltip="Common Names Detected"
								class="text-lg text-orange ml-3"
								[icon]="ICON.parties"
							></fa-icon>
						</div>
					</div>
				</div>
				<div class="w-1/2 pl-2">
					<div class="font-bold">Parties to</div>
					<div
						*ngFor="let name of instrument.parties_to; index as i"
						class="flex flex-col"
						[ngClass]="{
							'similar-name': instrument?.sameNamesToIndexes?.includes(i),
						}"
					>
						<div class="flex flex-row flex-1 items-center overflow-hidden">
							<span class="flex-1">
								{{ name | capitalize }}
							</span>
							<fa-icon
								*ngIf="instrument?.sameNamesToIndexes?.includes(i)"
								matTooltip="Common Names Detected"
								class="text-lg text-orange ml-3"
								[icon]="ICON.parties"
							></fa-icon>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
